(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["litania-material-film"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var namespace = 'LitaniaR5_film_20261002';
  if (window[namespace]) { window[namespace].mount(document); return; }
  var instances = new WeakMap();
/* Silent product media. Geometry is CSS-owned, never playback-state-owned. */
function mountMedia(root, on, cleanups) {
  root.querySelectorAll('[data-litania-video]').forEach(function (video) {
    try {
      var frame = video.parentElement;
      var button = frame.querySelector('[data-litania-media-toggle]');
      var errorNode = frame.querySelector('[data-litania-media-error]');
      var poster = frame.querySelector('[data-litania-video-poster]');
      var nativeControls = video.dataset.nativeControls === 'true';
      if (nativeControls) {
        video.controls = true;
        if (button) button.hidden = true;
        return; // An explicitly selected native player stays a manual, full player.
      }
      if (!button) return; // A stationary poster and text alternative remain.
      var name = video.getAttribute('aria-label') || 'product film';
      var playIcon = button.querySelector('[data-play]');
      var pauseIcon = button.querySelector('[data-pause]');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var saveData = !!(navigator.connection && navigator.connection.saveData);
      var intent = 'auto';
      var visible = false;
      var pending = false;
      var destroyed = false;
      var failed = false;
      var ticket = 0;
      var observed = 'IntersectionObserver' in window;
      function allowed() {
        return !destroyed && !failed && !document.hidden && visible && intent !== 'pause' &&
          (intent === 'play' || (observed && video.dataset.autoplay === 'true' && !reduced.matches && !saveData));
      }
      function sync() {
        var playing = !video.paused || pending;
        button.setAttribute('aria-label', (playing ? 'Pause ' : 'Play ') + name);
        if (playIcon) playIcon.toggleAttribute('hidden', playing);
        if (pauseIcon) pauseIcon.toggleAttribute('hidden', !playing);
        button.dataset.state = playing ? 'playing' : 'paused';
      }
      function pause() {
        ticket += 1;
        pending = false;
        video.pause();
        sync();
      }
      function play() {
        if (pending || !video.paused || !allowed()) return;
        pending = true;
        var attempt = ++ticket;
        sync();
        try {
          var result = video.play();
          if (result && typeof result.then === 'function') {
            result.then(function () {
              if (attempt === ticket) pending = false;
              if (!allowed()) pause();
              sync();
            }).catch(function () {
              if (attempt === ticket) pending = false;
              // Autoplay denial and interrupted requests are not media errors.
              sync();
            });
          } else { pending = false; sync(); }
        } catch (error) { pending = false; sync(); }
      }
      on(button, 'click', function () {
        if (!video.paused || pending) { intent = 'pause'; pause(); }
        else { intent = 'play'; visible = true; play(); }
      });
      on(video, 'play', function () { if (!allowed()) pause(); else sync(); });
      on(video, 'pause', sync);
      on(video, 'ended', function () { pending = false; intent = 'pause'; sync(); });
      on(video, 'error', function () {
        failed = true;
        intent = 'pause';
        pause();
        // A failed clip never switches to browser chrome or changes its crop.
        if (poster) { poster.hidden = false; video.hidden = true; }
        if (errorNode) errorNode.hidden = false;
        if (document.activeElement === button && errorNode) {
          errorNode.setAttribute('tabindex', '-1');
          errorNode.focus({ preventScroll: true });
        }
        button.hidden = true;
      });
      on(document, 'visibilitychange', function () { if (document.hidden) pause(); else play(); });
      function motionChange() {
        if (reduced.matches) { intent = 'pause'; pause(); }
        else play();
      }
      if (reduced.addEventListener) on(reduced, 'change', motionChange);
      else if (reduced.addListener) {
        reduced.addListener(motionChange);
        cleanups.push(function () { reduced.removeListener(motionChange); });
      }
      if (observed) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
            if (visible) play(); else pause();
          });
        }, { threshold: [0, 0.1, 0.4, 1] });
        observer.observe(frame);
        cleanups.push(function () { observer.disconnect(); });
      }
      video.controls = false;
      video.removeAttribute('autoplay');
      button.hidden = false;
      sync();
      if (video.error) video.dispatchEvent(new Event('error'));
      cleanups.push(function () { destroyed = true; pause(); });
    } catch (error) {
      console.warn('Litania: this film retains its stationary fallback.', error);
    }
  });
}

  function mount(root) {
    if (!root || instances.has(root)) return;
    var cleanups = [];
    function on(target, type, callback, options) {
      target.addEventListener(type, callback, options);
      cleanups.push(function () { target.removeEventListener(type, callback, options); });
    }
    function focusElement(element, scroll) {
      if (!element) return;
      if (!element.matches('input,button,select,textarea,a[href],summary,[tabindex]')) element.setAttribute('tabindex','-1');
      try { element.focus({ preventScroll: true }); } catch (error) { element.focus(); }
      if (scroll) {
        var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 86;
        var visualTarget = element.closest('.lpc__edition-card,.lpc__option-button,.lpc__ack') || element;
        var top = visualTarget.getBoundingClientRect().top + window.scrollY - header - 24;
        window.scrollTo({ top: Math.max(0,top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    }
    instances.set(root, function () {
      cleanups.reverse().forEach(function (cleanup) { try { cleanup(); } catch (error) { /* Dispose other components too. */ } });
      instances.delete(root);
    });
    mountMedia(root,on,cleanups);
  }
  function roots(scope) {
    var found = Array.from(scope.querySelectorAll('[data-litania-r5="film"]'));
    if (scope.matches && scope.matches('[data-litania-r5="film"]')) found.unshift(scope);
    return found;
  }
  function start(scope) {
    roots(scope).forEach(function (root) { try { mount(root); } catch (error) { console.warn('Litania: section fallback retained.',error); } });
  }
  document.addEventListener('shopify:section:load',function (event) { start(event.target); });
  document.addEventListener('shopify:section:unload',function (event) {
    roots(event.target).forEach(function (root) { var destroy=instances.get(root); if (destroy) destroy(); });
  });
  document.addEventListener('shopify:block:select',function (event) {
    if (event.target.closest) { var details=event.target.closest('details'); if (details) details.open=true; }
  });
  window[namespace]={mount:start};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { start(document); },{once:true});
  else start(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["litania-preorder-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var namespace = 'LitaniaR5_story_20261002';
  if (window[namespace]) { window[namespace].mount(document); return; }
  var instances = new WeakMap();

  function mount(root) {
    if (!root || instances.has(root)) return;
    var cleanups = [];
    function on(target, type, callback, options) {
      target.addEventListener(type, callback, options);
      cleanups.push(function () { target.removeEventListener(type, callback, options); });
    }
    function focusElement(element, scroll) {
      if (!element) return;
      if (!element.matches('input,button,select,textarea,a[href],summary,[tabindex]')) element.setAttribute('tabindex','-1');
      try { element.focus({ preventScroll: true }); } catch (error) { element.focus(); }
      if (scroll) {
        var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 86;
        var visualTarget = element.closest('.lpc__edition-card,.lpc__option-button,.lpc__ack') || element;
        var top = visualTarget.getBoundingClientRect().top + window.scrollY - header - 24;
        window.scrollTo({ top: Math.max(0,top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    }
    instances.set(root, function () {
      cleanups.reverse().forEach(function (cleanup) { try { cleanup(); } catch (error) { /* Dispose other components too. */ } });
      instances.delete(root);
    });
    on(root,'click',function (event) {
      var link=event.target.closest('[data-litania-scroll-to-product]');
      if (!link || !root.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      var destination;
      try { destination=new URL(link.href,window.location.href); } catch(error) { return; }
      if (destination.origin !== location.origin || destination.hash || destination.search) return;
      var area=Array.from(document.querySelectorAll('[id^="LitaniaProductCore-"][data-product-url]')).find(function (candidate) {
        if (!candidate.getClientRects().length) return false;
        try { return new URL(candidate.dataset.productUrl,location.href).pathname.replace(/\/$/,'') === destination.pathname.replace(/\/$/,''); }
        catch(error) { return false; }
      });
      if (!area) return; // A real href remains valid without a matching section.
      var fancy=area.querySelector('[data-lpc-options]');
      var target;
      if (fancy && !fancy.hidden) target=fancy.querySelector('input:checked:not(:disabled),select:not(:disabled)') || fancy.querySelector('input:not(:disabled)');
      if (!target) target=area.querySelector('[data-lpc-native-options]:not([hidden]) select:not(:disabled)');
      if (!target) target=area.querySelector('.lpc__title');
      if (!target) return;
      event.preventDefault();
      var sticky=area.querySelector('[data-lpc-sticky]');
      if (sticky) { sticky.hidden=true; sticky.setAttribute('inert',''); sticky.setAttribute('aria-hidden','true'); }
      focusElement(target,true);
    });

  }
  function roots(scope) {
    var found = Array.from(scope.querySelectorAll('[data-litania-r5="story"]'));
    if (scope.matches && scope.matches('[data-litania-r5="story"]')) found.unshift(scope);
    return found;
  }
  function start(scope) {
    roots(scope).forEach(function (root) { try { mount(root); } catch (error) { console.warn('Litania: section fallback retained.',error); } });
  }
  document.addEventListener('shopify:section:load',function (event) { start(event.target); });
  document.addEventListener('shopify:section:unload',function (event) {
    roots(event.target).forEach(function (root) { var destroy=instances.get(root); if (destroy) destroy(); });
  });
  document.addEventListener('shopify:block:select',function (event) {
    if (event.target.closest) { var details=event.target.closest('details'); if (details) details.open=true; }
  });
  window[namespace]={mount:start};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { start(document); },{once:true});
  else start(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["litania-product-core"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var namespace = 'LitaniaR5_product_20261002';
  if (window[namespace]) { window[namespace].mount(document); return; }
  var instances = new WeakMap();
/* Silent product media. Geometry is CSS-owned, never playback-state-owned. */
function mountMedia(root, on, cleanups) {
  root.querySelectorAll('[data-litania-video]').forEach(function (video) {
    try {
      var frame = video.parentElement;
      var button = frame.querySelector('[data-litania-media-toggle]');
      var errorNode = frame.querySelector('[data-litania-media-error]');
      var poster = frame.querySelector('[data-litania-video-poster]');
      var nativeControls = video.dataset.nativeControls === 'true';
      if (nativeControls) {
        video.controls = true;
        if (button) button.hidden = true;
        return; // An explicitly selected native player stays a manual, full player.
      }
      if (!button) return; // A stationary poster and text alternative remain.
      var name = video.getAttribute('aria-label') || 'product film';
      var playIcon = button.querySelector('[data-play]');
      var pauseIcon = button.querySelector('[data-pause]');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      var saveData = !!(navigator.connection && navigator.connection.saveData);
      var intent = 'auto';
      var visible = false;
      var pending = false;
      var destroyed = false;
      var failed = false;
      var ticket = 0;
      var observed = 'IntersectionObserver' in window;
      function allowed() {
        return !destroyed && !failed && !document.hidden && visible && intent !== 'pause' &&
          (intent === 'play' || (observed && video.dataset.autoplay === 'true' && !reduced.matches && !saveData));
      }
      function sync() {
        var playing = !video.paused || pending;
        button.setAttribute('aria-label', (playing ? 'Pause ' : 'Play ') + name);
        if (playIcon) playIcon.toggleAttribute('hidden', playing);
        if (pauseIcon) pauseIcon.toggleAttribute('hidden', !playing);
        button.dataset.state = playing ? 'playing' : 'paused';
      }
      function pause() {
        ticket += 1;
        pending = false;
        video.pause();
        sync();
      }
      function play() {
        if (pending || !video.paused || !allowed()) return;
        pending = true;
        var attempt = ++ticket;
        sync();
        try {
          var result = video.play();
          if (result && typeof result.then === 'function') {
            result.then(function () {
              if (attempt === ticket) pending = false;
              if (!allowed()) pause();
              sync();
            }).catch(function () {
              if (attempt === ticket) pending = false;
              // Autoplay denial and interrupted requests are not media errors.
              sync();
            });
          } else { pending = false; sync(); }
        } catch (error) { pending = false; sync(); }
      }
      on(button, 'click', function () {
        if (!video.paused || pending) { intent = 'pause'; pause(); }
        else { intent = 'play'; visible = true; play(); }
      });
      on(video, 'play', function () { if (!allowed()) pause(); else sync(); });
      on(video, 'pause', sync);
      on(video, 'ended', function () { pending = false; intent = 'pause'; sync(); });
      on(video, 'error', function () {
        failed = true;
        intent = 'pause';
        pause();
        // A failed clip never switches to browser chrome or changes its crop.
        if (poster) { poster.hidden = false; video.hidden = true; }
        if (errorNode) errorNode.hidden = false;
        if (document.activeElement === button && errorNode) {
          errorNode.setAttribute('tabindex', '-1');
          errorNode.focus({ preventScroll: true });
        }
        button.hidden = true;
      });
      on(document, 'visibilitychange', function () { if (document.hidden) pause(); else play(); });
      function motionChange() {
        if (reduced.matches) { intent = 'pause'; pause(); }
        else play();
      }
      if (reduced.addEventListener) on(reduced, 'change', motionChange);
      else if (reduced.addListener) {
        reduced.addListener(motionChange);
        cleanups.push(function () { reduced.removeListener(motionChange); });
      }
      if (observed) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            visible = entry.isIntersecting && entry.intersectionRatio >= 0.1;
            if (visible) play(); else pause();
          });
        }, { threshold: [0, 0.1, 0.4, 1] });
        observer.observe(frame);
        cleanups.push(function () { observer.disconnect(); });
      }
      video.controls = false;
      video.removeAttribute('autoplay');
      button.hidden = false;
      sync();
      if (video.error) video.dispatchEvent(new Event('error'));
      cleanups.push(function () { destroyed = true; pause(); });
    } catch (error) {
      console.warn('Litania: this film retains its stationary fallback.', error);
    }
  });
}

/* One native range, one visual divider. Images never resize as it moves. */
function mountComparisons(root, on, cleanups) {
  root.querySelectorAll('[data-ba-container]').forEach(function (container) {
    try {
      var range = container.querySelector('[data-ba-input]');
      var handle = container.querySelector('[data-ba-handle]');
      if (!range || !handle) return;
      var source = range.dataset.sourceLabel || 'original photograph';
      var result = range.dataset.resultLabel || 'finished pendant';
      var sourceLabel = container.querySelector('[data-ba-source-label]');
      var resultLabel = container.querySelector('[data-ba-result-label]');
      var pointer = null, startX = 0, startValue = Number(range.value), moved = false;
      function labels(value) {
        var width = container.clientWidth;
        [sourceLabel, resultLabel].forEach(function (label, i) {
          if (!label) return;
          label.hidden = false;
          var available = width * (i === 0 ? value : 100 - value) / 100;
          label.hidden = available < label.offsetWidth + 28;
        });
      }
      function update(value) {
        value = Number(value);
        if (!Number.isFinite(value)) value = 80;
        value = Math.max(0, Math.min(100, Math.round(value)));
        range.value = String(value);
        container.style.setProperty('--ba-position', value + '%');
        range.setAttribute('aria-valuetext', value + '% ' + source + ' visible; ' + (100 - value) + '% ' + result + ' visible');
        labels(value);
      }
      function point(x) {
        var bounds = container.getBoundingClientRect();
        if (bounds.width) update((x - bounds.left) / bounds.width * 100);
      }
      function cancel() {
        if (pointer === null) return;
        var id = pointer; pointer = null;
        update(startValue);
        container.classList.remove('is-dragging');
        if (range.hasPointerCapture && range.hasPointerCapture(id)) range.releasePointerCapture(id);
      }
      on(range, 'input', function () { update(range.value); });
      on(range, 'change', function () { update(range.value); });
      on(range, 'pointerdown', function (event) {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        event.preventDefault();
        pointer = event.pointerId; startX = event.clientX; startValue = Number(range.value); moved = false;
        range.focus({ preventScroll: true });
        if (range.setPointerCapture) range.setPointerCapture(pointer);
      });
      on(range, 'pointermove', function (event) {
        if (pointer !== event.pointerId) return;
        if (Math.abs(event.clientX - startX) >= 3) moved = true;
        if (moved) { container.classList.add('is-dragging'); point(event.clientX); }
      });
      on(range, 'pointerup', function (event) {
        if (pointer !== event.pointerId) return;
        point(event.clientX); // Click/tap without dragging is an equal alternative.
        var id = pointer; pointer = null;
        container.classList.remove('is-dragging');
        if (range.hasPointerCapture && range.hasPointerCapture(id)) range.releasePointerCapture(id);
        range.dispatchEvent(new Event('change', { bubbles: true }));
      });
      on(range, 'pointercancel', cancel);
      on(range, 'lostpointercapture', cancel);
      on(range, 'keydown', function (event) {
        if (event.key === 'Escape' && pointer !== null) { event.preventDefault(); cancel(); }
        if (event.key === 'PageUp' || event.key === 'PageDown') {
          event.preventDefault(); update(Number(range.value) + (event.key === 'PageUp' ? 10 : -10));
        }
        // Arrows, Home and End retain native range semantics, including AT input.
      });
      range.hidden = false; handle.hidden = false;
      container.dataset.ready = 'true';
      update(range.value);
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(function () { labels(Number(range.value)); });
        observer.observe(container);
        cleanups.push(function () { observer.disconnect(); });
      } else on(window, 'resize', function () { labels(Number(range.value)); });
      cleanups.push(cancel);
    } catch (error) { console.warn('Litania: static comparison retained.', error); }
  });
}

function mountZoom(root,on,cleanups) {
      root.querySelectorAll('[data-lpc-zoom-toggle]').forEach(function (button) {
        var frame = button.closest('[data-lpc-zoom-frame]');
        var wrapper = frame.querySelector('[data-lpc-zoom-wrapper]');
        if (!wrapper || !frame.querySelector('[data-lpc-hero-image]')) return;
        var zoomed = false, x = 50, y = 50;
        function sync() {
          frame.classList.toggle('is-zoomed', zoomed);
          wrapper.style.transformOrigin = x + '% ' + y + '%';
          button.setAttribute('aria-pressed', String(zoomed));
          button.setAttribute('aria-label', 'Enlarge product image');
        }
        on(button, 'click', function () { zoomed = !zoomed; x = y = 50; sync(); });
        on(frame, 'pointermove', function (event) {
          if (!zoomed || event.pointerType !== 'mouse') return;
          var rect = frame.getBoundingClientRect();
          x = Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100));
          y = Math.max(0, Math.min(100, (event.clientY - rect.top) / rect.height * 100));
          sync();
        });
        on(button, 'keydown', function (event) {
          if (!zoomed) return;
          if (event.key === 'Escape') zoomed = false;
          else if (event.key === 'ArrowLeft') x = Math.max(0, x - 10);
          else if (event.key === 'ArrowRight') x = Math.min(100, x + 10);
          else if (event.key === 'ArrowUp') y = Math.max(0, y - 10);
          else if (event.key === 'ArrowDown') y = Math.min(100, y + 10);
          else return;
          event.preventDefault(); sync();
        });
        button.hidden = false;
      });


}
function mountProduct(root,on,cleanups,focusElement) {
      var form = root.querySelector('.lpc__form');
      var dataNode = root.querySelector('[data-lpc-variant-data]');
      var configNode = root.querySelector('[data-lpc-config]');
      if (!form || !dataNode || !configNode) return;
      var variants, config;
      try { variants = JSON.parse(dataNode.textContent); config = JSON.parse(configNode.textContent); }
      catch (error) { console.warn('Litania: native variant chooser retained.', error); return; }
      if (!Array.isArray(variants) || !variants.length) return;
      var master = form.querySelector('[data-lpc-master-select]');
      var fancy = form.querySelector('[data-lpc-options]');
      var nativeOptions = form.querySelector('[data-lpc-native-options]');
      var submit = form.querySelector('[data-lpc-submit]');
      var label = form.querySelector('[data-lpc-submit-label]');
      if (!master || !fancy || !nativeOptions || !submit || !label) return;
      var actionLabel = submit.dataset.actionLabel;
      var groups = Array.from(fancy.querySelectorAll('[data-lpc-option-group]'));
      var inputs = Array.from(fancy.querySelectorAll('[data-lpc-option-input]'));
      var selects = Array.from(fancy.querySelectorAll('[data-lpc-option-select]'));
      var cards = Array.from(fancy.querySelectorAll('[data-lpc-edition-card]'));
      var mainPrice = root.querySelector('[data-lpc-main-price]');
      var mainTotal = root.querySelector('[data-lpc-main-total]');
      var comparePrice = root.querySelector('[data-lpc-compare-price]');
      var buttonPrice = form.querySelector('[data-lpc-submit-price]');
      var amount = form.querySelector('[data-lpc-submit-amount]');
      var status = form.querySelector('[data-lpc-status]');
      var pieceProperty = form.querySelector('[data-lpc-piece-property]');
      var sticky = form.querySelector('[data-lpc-sticky]');
      var stickyButton = form.querySelector('[data-lpc-sticky-submit]');
      var stickyPrice = form.querySelector('[data-lpc-sticky-price]');
      var stickyTitle = form.querySelector('[data-lpc-sticky-title]');
      var ack = form.querySelector('[data-lpc-ack]');
      var ackLabel = form.querySelector('[data-lpc-ack-label]');
      var ackError = form.querySelector('[data-lpc-form-error]');
      var selectionError = form.querySelector('[data-lpc-selection-error]');
      var hero = root.querySelector('[data-lpc-hero-image]');
      function decodeMoney(value) { var node=document.createElement('textarea'); node.innerHTML=String(value || ''); return node.value; }
      var busy = false;
      var resetTimer = 0;
      var postSubmitTimer = 0;
      var syncingMaster = false;
      var activeVariant = null;
      cards.forEach(function (card) {
        var perPiece = card.querySelector('[data-lpc-per-piece]');
        if (perPiece) perPiece.dataset.show = perPiece.hidden ? 'false' : 'true';
      });
      function selection() {
        var values = [];
        groups.forEach(function (group) {
          var chosen = group.querySelector('[data-lpc-option-input]:checked') || group.querySelector('[data-lpc-option-select]');
          values[Number(group.dataset.optionIndex)] = chosen ? chosen.value : null;
        });
        return values;
      }
      function exact(values) {
        if (!groups.length) return variants.find(function (variant) { return String(variant.id) === master.value; }) || null;
        return variants.find(function (variant) {
          return variant.options.length === values.length && variant.options.every(function (value,index) { return value === values[index]; });
        }) || null;
      }
      function setInputs(variant) {
        inputs.forEach(function (input) { input.checked = variant.options[Number(input.dataset.optionIndex)] === input.value; });
        selects.forEach(function (select) { select.value = variant.options[Number(select.dataset.optionIndex)]; });
      }
      function updateCards(values) {
        inputs.forEach(function (input) {
          var wrap = input.closest('.lpc__option-button');
          if (wrap) wrap.classList.toggle('is-selected', input.checked);
        });
        cards.forEach(function (card) {
          var input = card.querySelector('[data-lpc-option-input]');
          if (!input) return;
          var index = Number(input.dataset.optionIndex);
          var candidateValues = values.slice(); candidateValues[index] = input.value;
          var candidate = exact(candidateValues);
          var existsAvailable = variants.some(function (variant) { return variant.options[index] === input.value && variant.available; });
          input.disabled = !existsAvailable;
          card.classList.toggle('is-selected', input.checked);
          card.classList.toggle('is-unavailable', !existsAvailable);
          var cardPrice = card.querySelector('[data-lpc-edition-price]');
          if (cardPrice) cardPrice.textContent = candidate ? decodeMoney(candidate.priceText) : 'Unavailable';
          var totalNote = card.querySelector('[data-lpc-edition-total]');
          if (totalNote) totalNote.hidden = !(candidate && candidate.pieceCount > 1);
          var perPiece = card.querySelector('[data-lpc-per-piece]');
          if (perPiece) {
            perPiece.hidden = !(candidate && candidate.pieceCount > 1 && perPiece.dataset.show === 'true');
            perPiece.textContent = candidate ? decodeMoney(candidate.perPieceText) + ' each' : '';
          }
        });
      }
      function changeImage(variant) {
        if (!hero || config.lockHero) return;
        var image = variant && variant.image;
        if (image && image.src) {
          hero.src = image.src; hero.removeAttribute('srcset'); hero.alt = image.alt || hero.dataset.baseAlt || '';
        } else {
          hero.src = hero.dataset.baseSrc;
          if (hero.dataset.baseSrcset) hero.srcset = hero.dataset.baseSrcset;
          hero.alt = hero.dataset.baseAlt || '';
        }
      }
      function updateURL(variant) {
        if (root.dataset.isProductPage !== 'true' || root.dataset.linkedPair === 'true' || root.dataset.updateVariantUrl !== 'true') return;
        try {
          var url = new URL(window.location.href);
          if (variant) url.searchParams.set('variant', String(variant.id)); else url.searchParams.delete('variant');
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (error) { /* Buying does not depend on URL updates. */ }
      }
      function sync(announce, changeURL) {
        var values = selection();
        var variant = exact(values);
        activeVariant = variant;
        updateCards(values);
        var previousId = master.value;
        master.value = variant ? String(variant.id) : '';
        var available = !!(variant && variant.available);
        var price = variant ? decodeMoney(variant.priceText) : 'Unavailable';
        if (mainPrice) mainPrice.textContent = price;
        if (mainTotal) mainTotal.hidden = !(variant && variant.pieceCount > 1);
        if (stickyPrice) stickyPrice.textContent = variant ? price : '';
        if (stickyTitle) stickyTitle.textContent = variant && config.editionIndex >= 0 ? variant.options[config.editionIndex] : (root.querySelector('.lpc__title') || {}).textContent || '';
        if (comparePrice) { comparePrice.textContent = variant ? decodeMoney(variant.compareText) : ''; comparePrice.hidden = !(variant && variant.compareText); }
        if (buttonPrice) buttonPrice.textContent = available ? price : '';
        if (amount) amount.hidden = !(config.showButtonPrice && available);
        submit.disabled = !available || busy;
        submit.setAttribute('aria-disabled', String(!available || busy));
        if (stickyButton) { stickyButton.disabled = busy; stickyButton.setAttribute('aria-disabled', String(busy)); }
        label.textContent = busy ? config.adding : (!variant ? 'Choose another combination' : available ? actionLabel : config.soldOut);
        if (pieceProperty) { pieceProperty.disabled = !variant; pieceProperty.value = variant ? String(variant.pieceCount) : ''; }
        if (selectionError) {
          selectionError.hidden = !!variant;
          selectionError.textContent = variant ? '' : 'That combination is unavailable. Please choose another option.';
        }
        if (status && announce) status.textContent = !variant ? 'This combination is unavailable.' : !available ? config.soldOut : '';
        changeImage(variant);
        if (changeURL) updateURL(variant);
        if (previousId !== master.value) {
          syncingMaster = true;
          master.dispatchEvent(new Event('change', { bubbles: true }));
          syncingMaster = false;
          root.dispatchEvent(new CustomEvent('litania:variant-change', { bubbles: true, detail: { variant: variant } }));
        }
      }
      on(fancy, 'change', function (event) {
        if (event.target.matches('[data-lpc-option-input],[data-lpc-option-select]')) sync(true,true);
      });
      on(master, 'change', function () {
        if (syncingMaster) return;
        var variant = variants.find(function (item) { return String(item.id) === master.value; });
        if (variant) { setInputs(variant); sync(true,false); }
      });
      function showAckError() {
        if (!ack) return;
        ack.setAttribute('aria-invalid','true');
        if (ackLabel) ackLabel.classList.add('has-error');
        if (ackError) ackError.hidden = false;
        focusElement(ack,true);
      }
      if (ack) {
        on(ack,'invalid',function (event) { event.preventDefault(); showAckError(); });
        on(ack,'change',function () {
          if (ack.checked) {
            ack.setAttribute('aria-invalid','false');
            if (ackLabel) ackLabel.classList.remove('has-error');
            if (ackError) ackError.hidden = true;
          }
        });
      }
      function clearBusy() {
        window.clearTimeout(postSubmitTimer); window.clearTimeout(resetTimer); busy = false;
        submit.removeAttribute('aria-busy'); sync(false,false);
      }
      on(window,'pageshow',clearBusy);
      on(form,'submit',function (event) {
        if (busy) { event.preventDefault(); return; }
        if (ack && !ack.checked) { event.preventDefault(); showAckError(); return; }
        if (!activeVariant || !activeVariant.available || master.value !== String(activeVariant.id)) {
          event.preventDefault(); sync(true,false);
          focusElement(fancy.querySelector('input:not(:disabled),select'),true); return;
        }
        // Preserve Shopify's standard POST and app validation. Never resend an
        // uncertain cart request and never bypass the form with form.submit().
        window.clearTimeout(postSubmitTimer);
        postSubmitTimer = window.setTimeout(function () {
          if (event.defaultPrevented || !root.isConnected) return;
          busy = true; submit.setAttribute('aria-busy','true'); sync(false,false);
          resetTimer = window.setTimeout(clearBusy,12000);
        },0);
      });
      cleanups.push(function () { window.clearTimeout(postSubmitTimer); window.clearTimeout(resetTimer); });

      var raf = 0;
      function hideSticky(restoreFocus) {
        if (!sticky) return;
        if (restoreFocus !== false && sticky.contains(document.activeElement)) focusElement(submit,true);
        sticky.hidden = true; sticky.setAttribute('inert',''); sticky.setAttribute('aria-hidden','true');
        if (stickyButton) stickyButton.tabIndex = -1;
      }
      function updateSticky() {
        raf = 0;
        if (!sticky || !stickyButton) return;
        var mobile = window.matchMedia('(max-width:749px)').matches;
        var height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
        var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 86;
        var focused = document.activeElement;
        var focusInContent = root.contains(focused) && !sticky.contains(focused) && focused.matches('input,select,textarea,button,a,summary,[tabindex]');
        var modalOpen = Array.from(document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')).some(function (dialog) { var box = dialog.getBoundingClientRect(); var style = getComputedStyle(dialog); return !!dialog.getClientRects().length && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0 && box.bottom > 0 && box.top < window.innerHeight && box.right > 0 && box.left < window.innerWidth; });
        var rect = submit.getBoundingClientRect();
        var rootRect = root.getBoundingClientRect();
        var show = mobile && height >= 450 && rect.bottom < headerHeight && rootRect.bottom > 150 && !focusInContent && !modalOpen;
        if (!show) { hideSticky(); return; }
        sticky.hidden = false; sticky.removeAttribute('inert'); sticky.setAttribute('aria-hidden','false'); stickyButton.tabIndex = 0;
      }
      function scheduleSticky() { if (!raf) raf = window.requestAnimationFrame(updateSticky); }
      if (stickyButton) on(stickyButton,'click',function () {
        hideSticky(false);
        var target = fancy.querySelector('input:checked:not(:disabled),select') || (ack && !ack.checked ? ack : submit);
        focusElement(target,true);
      });
      on(window,'scroll',scheduleSticky,{passive:true});
      on(window,'resize',scheduleSticky,{passive:true});
      if (window.visualViewport) on(window.visualViewport,'resize',scheduleSticky,{passive:true});
      on(document,'focusin',scheduleSticky);
      cleanups.push(function () { window.cancelAnimationFrame(raf); });
      var initial = variants.find(function (variant) { return String(variant.id) === master.value; });
      if (initial) setInputs(initial);
      sync(false,false);
      // The usable native select stays in place if anything above failed.
      nativeOptions.hidden = true; fancy.hidden = false; root.dataset.lpcEnhanced = 'true';
      updateSticky();
}

  function mount(root) {
    if (!root || instances.has(root)) return;
    var cleanups = [];
    function on(target, type, callback, options) {
      target.addEventListener(type, callback, options);
      cleanups.push(function () { target.removeEventListener(type, callback, options); });
    }
    function focusElement(element, scroll) {
      if (!element) return;
      if (!element.matches('input,button,select,textarea,a[href],summary,[tabindex]')) element.setAttribute('tabindex','-1');
      try { element.focus({ preventScroll: true }); } catch (error) { element.focus(); }
      if (scroll) {
        var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 86;
        var visualTarget = element.closest('.lpc__edition-card,.lpc__option-button,.lpc__ack') || element;
        var top = visualTarget.getBoundingClientRect().top + window.scrollY - header - 24;
        window.scrollTo({ top: Math.max(0,top), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
    }
    instances.set(root, function () {
      cleanups.reverse().forEach(function (cleanup) { try { cleanup(); } catch (error) { /* Dispose other components too. */ } });
      instances.delete(root);
    });
    try { mountProduct(root,on,cleanups,focusElement); } catch(error) { console.warn('Litania: native variant chooser retained.',error); }
    try { mountComparisons(root,on,cleanups); } catch(error) { console.warn('Litania: static comparison retained.',error); }
    try { mountMedia(root,on,cleanups); } catch(error) { console.warn('Litania: stationary media retained.',error); }
    try { mountZoom(root,on,cleanups); } catch(error) { console.warn('Litania: standard image retained.',error); }
  }
  function roots(scope) {
    var found = Array.from(scope.querySelectorAll('[data-litania-r5="product"]'));
    if (scope.matches && scope.matches('[data-litania-r5="product"]')) found.unshift(scope);
    return found;
  }
  function start(scope) {
    roots(scope).forEach(function (root) { try { mount(root); } catch (error) { console.warn('Litania: section fallback retained.',error); } });
  }
  document.addEventListener('shopify:section:load',function (event) { start(event.target); });
  document.addEventListener('shopify:section:unload',function (event) {
    roots(event.target).forEach(function (root) { var destroy=instances.get(root); if (destroy) destroy(); });
  });
  document.addEventListener('shopify:block:select',function (event) {
    if (event.target.closest) { var details=event.target.closest('details'); if (details) details.open=true; }
  });
  window[namespace]={mount:start};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { start(document); },{once:true});
  else start(document);
})();

  } catch(e) { console.error(e); }
})();
})();
